export default __webpack_public_path__ + "anchor-shape.png";